import React, { useEffect } from "react";
import "./App.css";
import { useLocation } from "react-router-dom";
import AppRoutes from "./Routes/AppRoutes";

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return (
    <>
      <AppRoutes />
    </>
  );
}

export default App;
